module.exports = __webpack_public_path__ + "img/2 una.c360259a.jpg";